import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {

  /** remove html tag from content */
  transform(content: string): string {
    return content.replace(/<[^>]{1,10000}>/g, '');
  }

}
